module.exports = __webpack_public_path__ + "media/images/assign-schedule-display-914739ee65bf86eb979c5d8b4d8da3c1.svg";